import { Component } from '@angular/core';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { BadgeService } from 'src/app/services/badge.service';
import { LeaseSummaryArrayResults } from '../short-code-list/short-code-list.component';

@Component({
  selector: 'app-needs-action',
  templateUrl: './needs-action.component.html'
})
export class NeedsActionComponent extends ScrBaseComponent {

  constructor(private badgeService: BadgeService) { super(); }

  resultsLoaded(e: LeaseSummaryArrayResults): void {
    if (e.results && e.results.length !== undefined) {
      this.badgeService.updateLocally(data => {
        if (data.needsActionCount !== e.results.length) {
          const previous = data.needsActionCount;
          data.needsActionCount = e.results.length;
          this.log.debug('needs action count updated from ' + previous + ' to ' + data.needsActionCount);
          return data;
        }
        return undefined;
      });
    }
  }
}
